<template>
  <a href="#" class="link" @click.prevent="sendLogAndGoDetail(cellInfo)">
    <div class="thmb-box">
      <div class="picture-area">
        <WebpImage :imageInfo="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: altTitle}"/>
      </div>
      <div class="no-thumb" :aria-hidden="!isThumbnail" :style="`display: ${isThumbnail ? 'none' : 'flex'}`">
        <span class="alt-text">{{ alt }}</span>
      </div>
    </div>
    <em
      class="sjt"
      ref="title"
      v-title-list="{ 'titleList': cellInfo.title_list, 'callback': loaded }"
    />
  </a>
</template>

<script>
import CellMixIn from '@/mixins/cell.mixin'
import { titleList } from '@/common/resources/directives'
import _ from 'lodash'
import shave from 'shave'
import { sendEventLogSearchPopularContents } from '@/common/utils/log.v2.send'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'SearchPopularCell',
  components: { WebpImage },
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList
  },
  props: {
    index: Number
  },
  methods: {
    sendLogAndGoDetail (cellInfo) {
      sendEventLogSearchPopularContents({ cellInfo: cellInfo, index: this.index })
      this.goDetail(cellInfo)
    },
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    }
  }
}
</script>
